<template>
  <BaseView class="index-container">
    <div slot="contantView" class="content">
      <div class="index-panel">
        <HeaderView :active-index="0" />
        <section class="topNav">
          <div class="pictures-list">
            <!-- <div v-for="(item, index) in pictureList" :key="index" :class="index === current ? 'active' : ''">
              <img :src="item.imgUrl" alt="" class="pic-img" />
            </div> -->
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide v-for="(item, index) in pictureList" :key="index">
                <img :src="item.imgUrl" alt="" class="pic-img" />
              </swiper-slide>
              <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
            </swiper>
            <div class="index-title">
              <div>Smarter Steel Product For</div>
              <div>People And Planet</div>
            </div>
          </div>
        </section>
        
        <!-- <section class="about-us-section">
          <img src="../assets/spsc/about-us-img.png" class="about-us-img"/>
        </section> -->
        <section class="about-us-section">
          <img src="../assets/spsc/aboutUs.png" class="about-us-bg"/>
          <div class="about-us-info">
            <div class="title-group">
              <div class="text-title">ABOUT US</div>
              <div class="right-dot"></div>
            </div>
            <div class="text-line"></div>
            <div class="about-us-content">
              <div class="content-group">
                <div>SPSC is a Foundation Solutions company focussing on Waterfront and Bridge Construction market in AUS and Asia. We provide customised solutions to our core products such as piles,pile sheet,Wharf steel structure and conveyor belt... </div>
                <div>How we go about providing these solutions is what defines us as a market leader in our sector. While most companies provide steel on the basis where price is primarily the key determining factor, we typically work with Owners, EPC, Contractors and Consultants early into the project to understand the project nature and use of the infrastructure. We then customise a solution that best fits the objectives of the customer and their requirements. We provide design assistance, innovative technologies in our steel, fabrication and tailored logistics to provide overall cost savings and productivity to the project. </div>
                <div>Our company’s motto is provide customers with the best solutions. We firmly believe that by providing innovative solutions to our customers, we can stay ahead of the competition and continuously redefine and improve the way infrastructure is constructed.</div>
              </div>
              <div class="about-us-pic"></div>
            </div>
          </div> 
        </section>

        <section class="products-section">
          <div class="title-group">
              <div class="text-title">PROJECTS</div>
              <div class="right-dot"></div>
            </div>
            <div class="text-line"></div>
            <div class="products-list" ref="topList">
              <div class="product-item" v-for="(item, index) in productLists1" :key="item.id" @click="goProjectsPage(item)">
                <div class="product-pic">
                  <img :src="item.imgUrl" class="product-img" />
                </div>
                <div class="product-name">{{ item.name }}</div>
              </div>
            </div>
            <div class="products-list">
              <div class="product-item" v-for="(item, index) in productLists2" :key="item.id" @click="goProjectsPage(item)">
                <div class="product-pic">
                  <img :src="item.imgUrl" class="product-img" />
                </div>
                <div class="product-name">{{ item.name }}</div>
              </div>
            </div>
            <div class="switch-group">
              <div v-if="isRight" class="left-arrow-active" @click="scrollLeftInfo()"></div>
              <div v-else class="left-arrow"></div>
              <div v-if="isRight" class="right-arrow"></div>
              <div v-else class="right-arrow-active" @click="scrollRightInfo()"></div>
            </div>

        </section>

        <section class="our-vision-section">
          <img src="../assets/spsc/our-vision-bg.png" class="our-vision-bg"/>
          <div class="vision-info">
            <div class="title-group">
              <div class="text-title-vision">OUR VISION</div>
              <div class="right-dot-vision"></div>
            </div>
            <div class="text-line-vision"></div>
            <div class="left-marks">“</div>
            <div class="vision-text"> Our company creed, “customer service first”，allows Sino Pacific Supply Chain Co., Ltd. to provide all-around,</div>
            <div class="vision-text">high-quality and integrated services for customers in support of their project and operations needs.</div>
            <div class="right-marks">”</div>
          </div>
        </section>
        <FooterView />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from '@/components/BaseView.vue'
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'
import utils from '../utils/util'
import { Toast } from 'vant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  name: '',
  props: {

  },
  components: {
    BaseView,
    HeaderView,
    FooterView,
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOption: {
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 3000,
        },
        loop: true
      },
      isRight: false,
      current: 0,
      pictureList: [{
        id: 1,
        imgUrl: require('../assets/spsc/swipe1.png'),
      }, {
        id: 2,
        imgUrl: require('../assets/spsc/swipe2.png'),
      }, {
        id: 3,
        imgUrl: require('../assets/spsc/swipe3.png'),
      }, {
        id: 4,
        imgUrl: require('../assets/spsc/swipe4.png'),
      }, {
        id: 5,
        imgUrl: require('../assets/spsc/swipe5.png'),
      }],

      productLists:[{
        id: 1,
        imgUrl: require('../assets/spsc/services/project1.png'),
        name: 'Civic Building'
      }, {
        id: 2,
        imgUrl: require('../assets/spsc/services/project2.png'),
        name: 'Wharf Engineering Facilities'
      }, {
        id: 3,
        imgUrl: require('../assets/spsc/services/project3.png'),
        name: 'Mining Equipment&Facilities'
      }, {
        id: 4,
        imgUrl: require('../assets/spsc/services/project4.png'),
        name: 'Metal Fabrication And Machining Product'
      }, {
        id: 5,
        imgUrl: require('../assets/spsc/services/project5.png'),
        name: 'Piles'
      }, {
        id: 6,
        imgUrl: require('../assets/spsc/services/project6.png'),
        name: 'New Energy'
      }, {
        id: 7,
        imgUrl: require('../assets/spsc/services/project7.png'),
        name: 'Vessel And Tank'
      }, {
        id: 8,
        imgUrl: require('../assets/spsc/services/project8.png'),
        name: 'Hosting Equipment'
      }, {
        id: 9,
        imgUrl: require('../assets/spsc/services/project9.png'),
        name: 'Steel Tower'
      }, {
        id: 10,
        imgUrl: require('../assets/spsc/services/project10.png'),
        name: 'Trading Service'
      }],


      productLists1:[{
        id: 1,
        imgUrl: require('../assets/spsc/services/project1.png'),
        name: 'Civic Building'
      }, {
        id: 2,
        imgUrl: require('../assets/spsc/services/project2.png'),
        name: 'Wharf Engineering Facilities'
      }, {
        id: 3,
        imgUrl: require('../assets/spsc/services/project3.png'),
        name: 'Mining Equipment&Facilities'
      }, {
        id: 7,
        imgUrl: require('../assets/spsc/services/project7.png'),
        name: 'Vessel And Tank'
      }, {
        id: 8,
        imgUrl: require('../assets/spsc/services/project8.png'),
        name: 'Hosting Equipment'
      }],

      productLists11:[{
        id: 1,
        imgUrl: require('../assets/spsc/services/project1.png'),
        name: 'Civic Building'
      }, {
        id: 2,
        imgUrl: require('../assets/spsc/services/project2.png'),
        name: 'Wharf Engineering Facilities'
      }, {
        id: 3,
        imgUrl: require('../assets/spsc/services/project3.png'),
        name: 'Mining Equipment&Facilities'
      }, {
        id: 7,
        imgUrl: require('../assets/spsc/services/project7.png'),
        name: 'Vessel And Tank'
      }, {
        id: 8,
        imgUrl: require('../assets/spsc/services/project8.png'),
        name: 'Hosting Equipment'
      }],

      tmpProductLists1:[{
        id: 3,
        imgUrl: require('../assets/spsc/services/project3.png'),
        name: 'Mining Equipment&Facilities'
      }, {
        id: 7,
        imgUrl: require('../assets/spsc/services/project7.png'),
        name: 'Vessel And Tank'
      }, {
        id: 8,
        imgUrl: require('../assets/spsc/services/project8.png'),
        name: 'Hosting Equipment'
      }, {
        id: 1,
        imgUrl: require('../assets/spsc/services/project1.png'),
        name: 'Civic Building'
      }, {
        id: 2,
        imgUrl: require('../assets/spsc/services/project2.png'),
        name: 'Wharf Engineering Facilities'
      }],

      productLists2:[{
        id: 4,
        imgUrl: require('../assets/spsc/services/project4.png'),
        name: 'Metal Fabrication And Machining Product'
      }, {
        id: 5,
        imgUrl: require('../assets/spsc/services/project5.png'),
        name: 'Piles'
      }, {
        id: 6,
        imgUrl: require('../assets/spsc/services/project6.png'),
        name: 'New Energy'
      }, {
        id: 9,
        imgUrl: require('../assets/spsc/services/project9.png'),
        name: 'Steel Tower'
      }, {
        id: 10,
        imgUrl: require('../assets/spsc/services/project10.png'),
        name: 'Trading Service'
      }],
      productLists22:[{
        id: 4,
        imgUrl: require('../assets/spsc/services/project4.png'),
        name: 'Metal Fabrication And Machining Product'
      }, {
        id: 5,
        imgUrl: require('../assets/spsc/services/project5.png'),
        name: 'Piles'
      }, {
        id: 6,
        imgUrl: require('../assets/spsc/services/project6.png'),
        name: 'New Energy'
      }, {
        id: 9,
        imgUrl: require('../assets/spsc/services/project9.png'),
        name: 'Steel Tower'
      }, {
        id: 10,
        imgUrl: require('../assets/spsc/services/project10.png'),
        name: 'Trading Service'
      }],
      tmpProductLists2:[{
        id: 6,
        imgUrl: require('../assets/spsc/services/project6.png'),
        name: 'New Energy'
      }, {
        id: 9,
        imgUrl: require('../assets/spsc/services/project9.png'),
        name: 'Steel Tower'
      }, {
        id: 10,
        imgUrl: require('../assets/spsc/services/project10.png'),
        name: 'Trading Service'
      }, {
        id: 4,
        imgUrl: require('../assets/spsc/services/project4.png'),
        name: 'Metal Fabrication And Machining Product'
      }, {
        id: 5,
        imgUrl: require('../assets/spsc/services/project5.png'),
        name: 'Piles'
      }],
    }
  },
  methods: {
    goProjectsPage(item) {
      console.log('======item', item)
      this.$router.replace({ path: '/projects', query: {projectIndex: item.id} })
    },

    scrollLeftInfo () {
      console.log('====scrollLeft===')

      this.isRight = false
      this.productLists1 = this.productLists11
      this.productLists2 = this.productLists22
    },

    scrollRightInfo () {
      console.log('====scrollRight===', this.$refs.topList)
      this.isRight = true
      this.productLists1 = this.tmpProductLists1
      this.productLists2 = this.tmpProductLists2
      
    }
  },
  created () {
  }
}
</script>
<style scoped lang="scss">

.index-container {
  background: #FFFFFF;
  width: 100%;
}

.index-panel {
  width: 100%;
  min-width: 1200px;
}


.topNav {
  margin-top: -83px;
}

.pictures-list {
  position: relative;
}

.pic-img {
  width: 100%;
  height: auto;
}

.swiper {
  width: 100%;
}

/deep/ .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 40px;
    left: 0;
    width: 100%;
}

/deep/ .swiper-pagination-bullet {
  width: 12px;
  height: 4px;
  background: #FFFFFF;
  opacity: 0.4;
  border-radius: 0;
}

/deep/ .swiper-pagination-bullet-active {
  opacity: 1;
  width: 32px;
  height: 4px;
  background: #FFFFFF;
}

.index-title {
  width: 1200px;
  height: 160px;
  position: absolute;
  top: -100px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 9999;
  font-size: 68px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 80px;
  text-shadow: 0px 2px 4px rgba(0,0,0,0.3);

  animation: fadeInAnimation ease 3s; 
  animation-iteration-count: 1; /*设置动画播放次数*/
  animation-fill-mode: forwards; 
}

@keyframes fadeInAnimation { 
  0% { 
      opacity: 0; /*设置不透明度*/
  } 

  25% { 
      opacity: 0.25; /*设置不透明度*/
  }

  50% { 
      opacity: 0.5; /*设置不透明度*/
  }

  75% { 
      opacity: 0.75; /*设置不透明度*/
  }

  100% { 
      opacity: 1; 
  } 
} 

.about-us-section {
  width: 100%;
  height: 100%;
  min-width: 1200px;
}

.about-us-img {
  width: 100%;
  // height: auto;
  height: 860px;
}

.about-us-bg {
  width: 100%;
  height: 860px;
}

.about-us-info {
  width: 1200px;
  margin: -770px auto 0 auto;
}

// @media screen and (max-width: 1200px) {
//   .about-us-info {
//     width: 1200px;
//     margin: -770px auto 0 auto;
//   }
// }

// @media screen and (max-width: 1500px) and (min-width: 1201px) {
//   .about-us-info {
//     width: 1200px;
//     margin: -670px auto 0 auto;
//   }
// }

// @media screen and (max-width: 1920px) and (min-width: 1501px) {
//   .about-us-info {
//     width: 1200px;
//     margin: -770px auto 0 auto;
//   }
// }

// @media screen and (max-width: 2560px) and (min-width: 1921px) {
//   .about-us-info {
//     width: 1200px;
//     margin: -870px auto 0 auto;
//   }
// }

.title-group {
  display: flex;
}

.text-title {
  font-size: 40px;
  font-weight: bold;
  color: #111111;
  line-height: 40px;
}

.right-dot {
  width: 8px;
  height: 8px;
  background: #0281C1;
  margin-left: 16px;
  margin-top: 22px;
}

.text-line {
  width: 48px;
  height: 6px;
  background: #0281C1;
  margin-top: 20px;
  position: relative;
  z-index: 99;
}

.about-us-content {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}

.content-group {
  width: 780px;
  font-size: 16px;
  color: #333333;
  line-height: 40px;
}

.content-group div {
  margin-bottom: 20px;
}

.about-us-pic {
  width: 360px;
  height: 544px;
  background: url('../assets/spsc/about-us-pic.png') no-repeat;
  background-size: contain;
}

.products-section {
  width: 1200px;
  margin: 200px auto 86px auto;
  overflow: hidden;
}
.products-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin-top: 60px;
  // overflow-x: scroll;
  // overflow-y: hidden;
}

.product-item {
  width: 380px;
  height: 360px;
  margin-right: 30px;
  cursor: pointer;
}

.product-item:last-child {
  margin-right: 0;
}

.product-pic {
  width: 380px;
  height: 280px;
  overflow: hidden;
} 
.product-img {
  width: 380px;
  height: 280px;
  transition: all 0.6s;   
}

.product-pic img:hover {
  transform: scale(1.3);
}

.product-name {
  width: 380px;
  height: 80px;
  background: #1587C0;
  font-size: 24px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 80px;
  text-align: center;
}

.switch-group {
  width: 1200px;
  margin: 60px auto 0 auto;
  display: flex;
  justify-content: center;
}

.left-arrow {
  width: 48px;
  height: 48px;
  background: url('../assets/spsc/left-arrow.png') no-repeat;
  background-size: contain;
  margin-right: 32px;
  cursor: not-allowed;
}

.left-arrow-active {
  width: 48px;
  height: 48px;
  background: url('../assets/spsc/left-arrow-active.png') no-repeat;
  background-size: contain;
  margin-right: 32px;
  cursor: pointer;
}

.right-arrow {
  width: 48px;
  height: 48px;
  background: url('../assets/spsc/right-arrow.png') no-repeat;
  background-size: contain;
  cursor: not-allowed;
}

.right-arrow-active {
  width: 48px;
  height: 48px;
  background: url('../assets/spsc/right-arrow-active.png') no-repeat;
  background-size: contain;
  cursor: pointer;
}


.our-vision-section {
  width: 100%;
  height: 480px;
  min-width: 1200px;
}

.our-vision {
  width: 100%;
  margin-bottom: -6px;
}

.our-vision-bg {
  width: 100%;
  // height: auto;
  height: 480px;
}

.vision-info {
  width: 1200px;
  height: 280px;
  margin: -380px auto 0 auto;
}

.our-vision-content {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  z-index: 99;
}

.text-title-vision {
  font-size: 40px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 40px;
}

.right-dot-vision {
  width: 8px;
  height: 8px;
  background: #FFFFFF;
  margin-left: 16px;
  margin-top: 22px;
}

.text-line-vision {
  width: 48px;
  height: 6px;
  background: #FFFFFF;
  margin-top: 20px;
  position: relative;
  z-index: 999;
}

.left-marks {
  font-size: 48px;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: 80px;
  line-height: 20px;
}

.vision-text {
  width: 1110px;
  margin: 0 auto;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 36px;
}

.right-marks {
  font-size: 48px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 48px;
  text-align: right;
}
</style>
